import { Currency } from "@redotech/money/currencies";
import * as z from "zod/v4";

export const getLoyaltyCustomerInfo = {
  name: "getLoyaltyCustomerInfo" as const,
  input: z.object({
    customerId: z.string(),
    currency: z.enum(Currency),
    storeUrl_forCacheRoutingOnly: z.string(),
  }),
  output: z.object({
    pointsBalance: z.number(),
    singlePointValue: z.object({
      currency: z.enum(Currency),
      amount: z.number(),
    }),
    loyaltyDashboardUrl: z.string().optional(),
    customerName: z.string().optional(),
  }),
};
